import React from "react";
import { ImagePath } from "../../../assets/ImagePath";

export const AuthRightPanel = ({ bgImage }) => {
    const panelBgImage = bgImage ||'';

    return (
        <div        
            className=" sm:col-span-6 col-span-12 sm:block hidden relative w-full h-full"
            style={{
                backgroundImage: `url(${panelBgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
        </div>
    );
};
